import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { Stepper, StepperChangeEvent } from '@progress/kendo-react-layout';
import EWDPersonalInfoFieldsNew from './components/EWDPersonalInfoFields';
import EWDParentDetailsNew from './components/EWDParentDetails';
import EWDDivisionsNew from './components/EWDDivisons';
import {
  ApiError,
  EWD,
  EwdService,
  GeneralEWDs,
  GeneralLookup,
  GeneralLookupWrapper,
  LookupService,
  RiderService,
} from 'services/openapi';
import useApi from 'services/mavapi/useApi';
import { EligibilityDetailsNew } from './components/ElgibilityDetails';
import EligibilityConditionsNew from './components/ElgibilityConditions';
import { EquipmentDetailsNew } from './components/EquimentDetails';
import AdaptiveEquipmentsNew from './components/AdaptiveEquipments';
import check from './assets/img/icon/check.png';
import LoaderWrapper from 'app/components/CircularLoader/LoaderWrapper';
import CircularLoader from 'app/components/CircularLoader';
import { useManagePageSlice } from 'app/pages/slice';
import { selectPageLoader } from 'app/pages/slice/selectors';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import Box from '@mui/joy/Box';
import CircularProgress from '@mui/joy/CircularProgress';
import { heightWeightModel } from 'app/pages/RiderRegistrationPage/components/NotReturningRider';
import { useRiderRegistrationStateSlice } from 'app/pages/RiderRegistrationPage/slice';
import { selectPhotoUpload } from 'app/pages/RiderRegistrationPage/slice/selectors';
import { useEwdRegistrationStateSlice } from '../../slice';
import isApiError from 'utils/isApiError';
import { selectDiagonosissUpload } from '../../slice/selectors';
import { useErrorHandlingSlice } from 'app/error/slice';
import { defaultPhotoValue, defaultValue } from '../../staticData';
import { getLookupArray } from 'utils/common';

const items = [
  { label: 'Personal Information', number: 1 },
  { label: 'Parent', number: 2 },
  // { label: 'Affiliations', number: 3 },
  { label: 'EWD Divisions', number: 3 },
  { label: 'Diagonosis Form', number: 4 },
  { label: 'Diagonosis Condition', number: 5 },
];

const EWDNewMember = () => {
  const { error: apiError, handleRequest } = useApi();
  const [, setError] = React.useState<ApiError | unknown>();
  const {
    ewdCreateEwd,
    ewdCreateEwdDiagnosis,
    ewdUploadEwdPhoto,
    ewdUploadDiagnosisData,
  } = EwdService;
  const { riderGetBackNumberList } = RiderService;
  const { actions: manageAppActions } = useRiderRegistrationStateSlice();
  const [value, setValue] = React.useState<number>(0);
  const { actions } = useErrorHandlingSlice();
  const navigate = useNavigate();
  const [newMemberData, setNewMemberData] = useState<EWD>(defaultValue);
  const [showStepper, setShowStepper] = useState(true);
  const [responseId, setResponseId] = useState<string>();
  const { actions: PageActions } = useManagePageSlice();
  const { actions: manageEwdActions } = useEwdRegistrationStateSlice();
  const pageLoader = useSelector(selectPageLoader);
  const dispatch = useDispatch();
  const { lookupGetAllLookups } = LookupService;
  const [cancelPaymentCookie, setCancelPaymentCookie] = useState();
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 767);
  const [heightWeight, setHeightWeight] = useState<heightWeightModel>({
    feet: undefined,
    inches: undefined,
    weight: undefined,
  });
  const [seasonDivison, setSeasonDivision] = useState<
    (string[] | undefined)[] | undefined
  >([]);
  const [isphotoforPromotion, setIsphotoforPromotion] = useState<
    boolean | null
  >(null);
  const [photoUploadPayload, setPhotoUploadPayload] = useState<{
    formData?: {
      file?: Blob;
    };
  }>(defaultPhotoValue);
  const [fileAvailability, setFileAvailability] = React.useState<boolean>(true);
  const [uploadFile, setUploadFile] = useState<File | null>();
  const photoUploadDataRedux = useSelector(selectPhotoUpload);

  const totalPages = 5;
  const determinateValue = ((value + 1) / totalPages) * 100;
  const [backNumberData, setBackNumberData] = React.useState<
    string[] | undefined
  >([]);
  const [otherData, setOtherData] = useState<string>('');
  const [diagonosisUploadPayload, setDiagonosisUploadPayload] =
    useState<Blob>();
  const [diagonosisFileAvailability, setDiagonosisFileAvailability] =
    React.useState<boolean>(true);
  const [diagonosisUploadFile, setDiagonosisUploadFile] =
    useState<File | null>();
  const diagonosisUploadDataRedux = useSelector(selectDiagonosissUpload);

  function getBackNumberList() {
    handleRequest(riderGetBackNumberList())
      .then(data => {
        setBackNumberData(data);
      })
      .catch(() => setError(apiError));
  }

  const handleChangeStepper = (e: StepperChangeEvent) => {
    const index = Number(e.value);
    if (index >= 0 && index !== value) {
      setValue(index);
    }
  };
  const handleItemClick = (index: number) => { };

  const handlePersonalNxt = () => {
    setValue(1);
  };
  const handleParentNxtBack = () => {
    setValue(0);
  };
  const handleParentNxt = () => {
    setValue(2);
  };
  // const handleAffiliationsBack = () => {
  //   setValue(1);
  // };
  // const handleAffiliationsNxt = () => {
  //   setValue(3);
  // };
  const handleDivionsBack = () => {
    setValue(1);
    Cookies.remove('paymentCancel');
    Cookies.remove('payload');
    Cookies.remove('diaganosisPayload');
  };

  const [teamData, setTeamData] = useState<GeneralLookup[]>([]);
  const [stateData, setStateData] = useState<GeneralLookup[]>([]);
  const [categoryData, setCategoryData] = useState<GeneralLookup[]>([]);
  const [lookUp, setLookUp] = useState<GeneralLookupWrapper[]>([]);
  const [medicalConditionsData, setMedicalConditionsData] = useState<
    GeneralLookup[]
  >([]);
  const [payerTypes, setPayerTypes] = useState<GeneralLookup>();
  const [ewdDivision, setEwdDivision] = useState<GeneralLookup[]>();
  const [isNotImage, setIsNotImage] = useState(false);

  const handleEwdNewMemberSubmit = (requestBody?: EWD) => {
    dispatch(PageActions.setPageLoader(true));
    handleRequest(ewdCreateEwd(requestBody))
      .then(res => {
        if (res && !isApiError(res)) {
          Cookies.set('responseId', JSON.stringify(res));
          if (photoUploadPayload?.formData?.file !== undefined) {
            handlePhotoUpload(res.toString(), photoUploadPayload.formData);
          }
          setValue(3);
          setResponseId(res);
          setShowStepper(!showStepper);
          dispatch(
            actions.dispatchToast({
              errorTxt: 'EWD rider registered successful',
              show: true,
              errorType: 'success',
            }),
          );
          dispatch(manageAppActions.setPhotoUpload(photoUploadPayload));
          dispatch(PageActions.setPageLoader(false));
        } else {
          dispatch(
            actions.dispatchToast({
              errorTxt: res.description,
              show: true,
              errorType: 'error',
            }),
          );
          dispatch(PageActions.setPageLoader(false));
        }
      })
      .catch(error => {
        setError(apiError);
        dispatch(
          actions.dispatchToast({
            errorTxt: error.description,
            show: true,
            errorType: 'error',
          }),
        );
        dispatch(PageActions.setPageLoader(false));
      });
  };
  const handlePhotoUpload = (
    riderId: string,
    formData?: {
      file?: Blob;
    },
  ) => {
    handleRequest(ewdUploadEwdPhoto(riderId, formData))
      .then(res => { })
      .catch(error => { });
  };
  const handleDiagonosisFormUpload = (formData?: {
    File: Blob;
    ApplicationId: string;
  }) => {
    handleRequest(ewdUploadDiagnosisData(formData))
      .then(res => { })
      .catch(error => { });
  };

  const handleEligibilityDetailsBack = () => {
    setShowStepper(!showStepper);
    setValue(2);
  };
  const handleEligibilityDetailsNext = () => {
    setValue(4);
  };
  const handleEligibilityConditionsBack = () => {
    setValue(3);
  };

  const handleEqupmentDetailsBack = () => {
    setValue(4);
  };
  const handleEqupmentDetailsNext = () => {
    setValue(6);
  };
  const handleEquipmentCheckboxNext = () => {
    // setValue(4);
  };
  const handlekEquipmentCheckboxBack = () => {
    setValue(5);
  };
  //HAndle get lookups
  const handleGetLookups = () => {
    dispatch(PageActions.setPageLoader(true));
    handleRequest(
      lookupGetAllLookups(
        'STATE,TEAM,PROFESSIONALAFFILIATIONS,MEDICALCONDITIONS,PAYER_TYPES,CATEGORY,DIVISION,ACTIVETEAM',
      ),
    )
      .then(res => {
        setLookUp(res);
        let varTeam = res?.filter(item => {
          if (item?.type === 'TEAM') {
            return item.values;
          }
        });
        let varState = res?.filter(item => {
          if (item?.type === 'STATE') {
            return item.values;
          }
        });
        let varCategories = res?.filter(item => {
          if (item?.type === 'CATEGORY') {
            return item?.values?.map(data => {
              if (data.name === 'EWD') {
                return setCategoryData(data?.children!);
              }
            });
          }
        });
        let varPayerTypes = res?.filter(item => {
          if (item?.type === 'PAYER_TYPES') {
            return item.values;
          }
        });
        let varMedicalConditions = res?.filter(item => {
          if (item?.type === 'MEDICALCONDITIONS') {
            return item.values?.map(e => {
              return e.name;
            });
          }
        });
        let payerTypeObj = varPayerTypes?.[0]?.values?.find(item => {
          if (item?.name === 'Rider') {
            return item ?? {};
          }
        });
        let varDivison = res?.filter(item => {
          if (item?.type === 'DIVISION') {
            return item.values;
          }
        });
        let filteredDIvison = varDivison?.map(item =>
          item.values?.map(data => data.name),
        );
        res?.filter(item => {
          if (item.type === 'CATEGORY') {
            return item.values?.map(data => {
              if (data.name === 'EWD') {
                return setEwdDivision(data.children!);
              }
            });
          }
        });

        setTeamData(varTeam?.[0]?.values!);
        setStateData(varState?.[0]?.values!);
        setCategoryData(varCategories?.[0]?.values!);
        setMedicalConditionsData(varMedicalConditions?.[0]?.values!);
        setPayerTypes(payerTypeObj);
        setSeasonDivision(filteredDIvison);

        dispatch(PageActions.setPageLoader(false));
      })

      .catch(error => {
        dispatch(PageActions.setPageLoader(false));
      });
  };

  const defaultData: GeneralEWDs = {
    riderId: responseId!,
    physicianName: '',
    physicianLicense: '',
    physicianPracticeLocation: '',
    medicalConditions: [],
  };
  const [diaganosisData, setDiaganosisData] =
    useState<GeneralEWDs>(defaultData);

  const handleEligibilityConditionsNext = () => {
    dispatch(PageActions.setPageLoader(true));
    const ewdRegisterCookie = Cookies.get('responseId');
    const diagnosisPayload = {
      ...diaganosisData,
      riderId: ewdRegisterCookie ? JSON.parse(ewdRegisterCookie) : responseId,
    };
    handleRequest(ewdCreateEwdDiagnosis(diagnosisPayload))
      .then(res => {
        const uploadPayload = {
          File: diagonosisUploadPayload as Blob,
          ApplicationId: res,
        };
        Cookies.set(
          'diagnosisFormUploadPayload',
          JSON.stringify(uploadPayload),
        );
        if (res && !isApiError(res)) {
          if (cancelPaymentCookie) {
            Cookies.remove('paymentCancel');
          }
          dispatch(
            manageEwdActions.setDiagonosisPayloadUpload(
              diagonosisUploadPayload,
            ),
          );
          handleDiagonosisFormUpload(uploadPayload);
          const newMemberDataString = JSON.stringify(newMemberData);
          const diaganosisDataString = JSON.stringify(diaganosisData);
          Cookies.set('OtherMedicalConditionData', otherData);
          Cookies.set('payload', newMemberDataString);
          Cookies.set('diaganosisPayload', diaganosisDataString);
          dispatch(PageActions.setPageLoader(false));
          dispatch(
            actions.dispatchToast({
              errorTxt: 'Submitted successfully',
              show: true,
              errorType: 'success',
            }),
          );
          navigate(
            `/payment/${payerTypes?.id}/${ewdRegisterCookie ? JSON.parse(ewdRegisterCookie) : responseId
            }/false/false`,
          );
          // setValue(6);
        } else {
          dispatch(
            actions.dispatchToast({
              errorTxt: res.description,
              show: true,
              errorType: 'error',
            }),
          );
          dispatch(PageActions.setPageLoader(false));
        }
      })
      .catch(error => {
        dispatch(
          actions.dispatchToast({
            errorTxt: error.description,
            show: true,
            errorType: 'error',
          }),
        );
        dispatch(PageActions.setPageLoader(false));
      });
  };
  React.useEffect(() => {
    //Lookups function call
    handleGetLookups();
    // handleGetTeamLookup();
    getBackNumberList();

    //payment cancel
    const paymentCancelStatus = Cookies.get('paymentCancel');
    setCancelPaymentCookie(paymentCancelStatus);

    //screen size handling for small sizes
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 767);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const newMemberData = Cookies.get('payload');
    const newDiaganosisData = Cookies.get('diaganosisPayload');
    if (newMemberData) {
      const newMemberDataParse = JSON.parse(newMemberData);
      setNewMemberData(newMemberDataParse);
      setShowStepper(false);
      setValue(4);
      setIsphotoforPromotion(newMemberDataParse.usePhotoForPromotion);
      setNewMemberData(newMemberDataParse);
      const heightInCm = newMemberData?.height || 0;
      const totalInches = heightInCm / 2.54;
      const feet = Math.floor(totalInches / 12);
      const inches = Math.round(totalInches % 12);
      setHeightWeight({
        feet: feet || undefined,
        inches: inches || undefined,
        weight: newMemberDataParse.weight,
      });
      setPhotoUploadPayload(photoUploadDataRedux ?? {});
      setUploadFile(photoUploadDataRedux?.formData?.file as File);
      setDiagonosisUploadPayload(diagonosisUploadDataRedux);
      setDiagonosisUploadFile(diagonosisUploadDataRedux as File);
      const OtherMedicalConditionData = Cookies.get(
        'OtherMedicalConditionData',
      );
      setOtherData(OtherMedicalConditionData);
    }
    if (newDiaganosisData) {
      const newDiaganosisDataParse = JSON.parse(newDiaganosisData);
      setDiaganosisData(newDiaganosisDataParse);
    }
  }, [cancelPaymentCookie]);
  useEffect(() => {
    dispatch(manageEwdActions.setFormValue(value));
  }, [value]);
  return (
    <>
      {pageLoader ? (
        <LoaderWrapper>
          <CircularLoader />
        </LoaderWrapper>
      ) : (
        <MainWrapper>
          <>
            <p className="Team-Heading">New Member</p>
            <div className="Stepper-wrapper">
              {isSmallScreen ? (
                <Box
                  sx={{
                    display: 'flex',
                    gap: 2,
                    alignItems: 'center',
                    flexWrap: 'wrap',
                  }}
                >
                  <CircularProgress
                    size="lg"
                    determinate
                    value={determinateValue}
                  >
                    {`${value + 1} / ${totalPages}`}
                  </CircularProgress>
                  {items
                    .filter((_, index) => index === value)
                    .map((item, index) => (
                      <h2 className="circular-stepper-heading" key={index}>
                        {item.label}
                      </h2>
                    ))}
                </Box>
              ) : (
                <Stepper
                  value={value}
                  onChange={handleChangeStepper}
                  items={items}
                  className="form-stepper"
                >
                  {items.map((item, index) => (
                    <StepperStep
                      key={index}
                      className={`stepper-step ${index < value ? 'completed' : ''
                        }`}
                      onClick={() => handleItemClick(index)}
                    >
                      {index < value ? (
                        <span className="tick-icon">&#10003;</span>
                      ) : (
                        item.number
                      )}
                    </StepperStep>
                  ))}
                </Stepper>
              )}
            </div>
            <>
              {value === 0 && (
                <EWDPersonalInfoFieldsNew
                  onClickNxtPersonal={handlePersonalNxt}
                  setNewMemberData={setNewMemberData}
                  newMemberData={newMemberData}
                  teamDetails={getLookupArray('ACTIVETEAM', lookUp)}
                  stateData={stateData}
                  setHeightWeight={setHeightWeight}
                  heightWeight={heightWeight}
                  backNumberData={backNumberData}
                />
              )}
              {value === 1 && (
                <EWDParentDetailsNew
                  onClickBackParent={handleParentNxtBack}
                  onClickNxtParent={handleParentNxt}
                  setNewMemberData={setNewMemberData}
                  newMemberData={newMemberData}
                  stateData={stateData}
                />
              )}
              {/* {value === 2 && (
                <EWDAffiliationsNew
                  onClickBackAffiliations={handleAffiliationsBack}
                  onClickNxtAffiliations={handleAffiliationsNxt}
                  setNewMemberData={setNewMemberData}
                  newMemberData={newMemberData}
                  affiliationsData={affiliationsData}
                />
              )} */}
              {value === 2 && (
                <EWDDivisionsNew
                  onClickBackDivions={handleDivionsBack}
                  handleEwdNewMemberSubmit={handleEwdNewMemberSubmit}
                  setNewMemberData={setNewMemberData}
                  newMemberData={newMemberData}
                  categoryData={categoryData}
                  ewdDivision={ewdDivision}
                  seasonDivison={seasonDivison}
                  setIsphotoforPromotion={setIsphotoforPromotion}
                  isphotoforPromotion={isphotoforPromotion}
                  setPhotoUploadPayload={setPhotoUploadPayload}
                  photoUploadPayload={photoUploadPayload}
                  setFileAvailability={setFileAvailability}
                  fileAvailability={fileAvailability}
                  setUploadFile={setUploadFile}
                  uploadFile={uploadFile}
                  setIsNotImage={setIsNotImage}
                  isNotImage={isNotImage}
                />
              )}
              {value === 3 && (
                <EligibilityDetailsNew
                  onClickEligibilityDetailsBack={handleEligibilityDetailsBack}
                  onClickEligibilityDetailsNext={handleEligibilityDetailsNext}
                  setNewMemberData={setNewMemberData}
                  newMemberData={newMemberData}
                  stateData={stateData}
                  teamData={teamData}
                />
              )}
              {value === 4 && (
                <EligibilityConditionsNew
                  handleEligibilityConditionsNext={
                    handleEligibilityConditionsNext
                  }
                  onClickEligibilityConditionsBack={
                    handleEligibilityConditionsBack
                  }
                  diaganosisData={diaganosisData}
                  setDiaganosisData={setDiaganosisData}
                  setValue={setValue}
                  responseId={responseId}
                  payerTypes={payerTypes}
                  medicalConditionsData={medicalConditionsData}
                  setOtherData={setOtherData}
                  otherData={otherData}
                  diagonosisUploadPayload={diagonosisUploadPayload}
                  setDiagonosisUploadPayload={setDiagonosisUploadPayload}
                  diagonosisFileAvailability={diagonosisFileAvailability}
                  diagonosisUploadFile={diagonosisUploadFile}
                  setDiagonosisFileAvailability={setDiagonosisFileAvailability}
                  setDiagonosisUploadFile={setDiagonosisUploadFile}
                />
              )}
              {value === 5 && (
                <EquipmentDetailsNew
                  onClickEqupmentDetailsNext={handleEqupmentDetailsNext}
                  onClickEqupmentDetailsBack={handleEqupmentDetailsBack}
                  setNewMemberData={setNewMemberData}
                  newMemberData={newMemberData}
                  stateData={stateData}
                  teamData={teamData}
                />
              )}
              {value === 6 && (
                <AdaptiveEquipmentsNew
                  onClickEquipmentCheckboxNext={handleEquipmentCheckboxNext}
                  onClickEquipmentCheckboxBack={handlekEquipmentCheckboxBack}
                />
              )}
            </>
          </>
        </MainWrapper>
      )}
    </>
  );
};

const MainWrapper = styled.div`
  .circular-stepper-heading {
    color: #8a8a8a;
  }
  .MuiCircularProgress-progress,
  .MuiCircularProgress-sizeLg {
    color: #8a8a8a;
    stroke: #2dce98;
  }
  .css-zitgxn-JoyCircularProgress-track {
    stroke: #434343;
  }
  .k-step-done {
    .k-step-indicator-text {
      position: relative;
      ::after {
        position: absolute;
        content: '';
        z-index: 15;
        background: #2dce98;
        background-image: url(${check});
        background-repeat: no-repeat;
        background-size: inherit;
        background-position: center;
        border-radius: 50px;
        left: -8px;
        height: 26px;
        width: 26px;
        top: -1px;
      }
    }
  }
  height: 100%;
  width: 100%;
  display: flex;
  padding-top: 30px;
  flex-direction: column;
  align-items: center;
  .k-stepper.form-stepper {
    pointer-events: none;
  }
  input {
    ::placeholder {
      font-size: 14px;
      text-transform: capitalize;
    }
  }
  .k-stepper .k-step-indicator::after {
    box-shadow: unset !important;
  }
  .k-stepper .k-step-indicator::after {
    border-style: unset !important;
  }
  .k-stepper .k-step-label .k-step-text {
    width: 200px;
    flex-grow: 1;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    color: #8a8a8a;
    font-size: 12px;
    max-width: unset !important;
  }
  .k-progressbar {
    background: #5b5b5b;
  }
  .k-progressbar .k-selected {
    background: #2dce98;
  }
  .k-stepper .k-step-done .k-step-indicator {
    border-color: #2dce98;
    color: white;
    background-color: #2dce98;
  }
  .k-stepper .k-step-current .k-step-indicator {
    border-color: #2dce98;
    color: white;
    background-color: #2dce98;
  }
  .k-stepper .k-step-indicator {
    border-color: #5b5b5b;
    color: #c4c4c4;
    background-color: #5b5b5b;
    width: 25px;
    height: auto;
  }
  .k-stepper {
    padding-bottom: 20px;
  }

  @media (min-width: 100px) and (max-width: 319px) {
    .Stepper-wrapper {
      width: -webkit-fill-available;
      .MuiBox-root {
        height: 55px;
        gap: 5px;
      }
      .circular-stepper-heading {
        font-size: 13px;
      }
      .MuiCircularProgress-root {
        --CircularProgress-size: 50px;
      }
    }
    .k-stepper .k-step-label .k-step-text {
      width: 55px;
      font-size: 10px;
    }
  }
  @media (min-width: 320px) and (max-width: 575px) {
    .Stepper-wrapper {
      width: -webkit-fill-available;
      .MuiBox-root {
        height: 55px;
        padding: 0 5px;
      }
      .circular-stepper-heading {
        font-size: 18px;
      }
      .MuiCircularProgress-root {
        --CircularProgress-size: 55px;
      }
    }
    .k-stepper .k-step-label .k-step-text {
      width: 55px;
      font-size: 11px;
    }
  }
  @media (min-width: 576px) and (max-width: 767px) {
    .Stepper-wrapper {
      width: -webkit-fill-available;
      .MuiBox-root {
        height: 55px;
        padding: 0 5px;
        gap: 25px;
      }
      .circular-stepper-heading {
        font-size: 22px;
      }
    }
  }
`;
const StepperStep = styled.button`
  background-color: green !important;
  color: white;
  border: none;
  padding: 10px;
  border-radius: 50%;
  font-weight: bold;

  &.completed {
    background-color: green !important;
  }
`;
export default EWDNewMember;
